export const submissionStatuses = {
  ALL: {
    text: 'datagate.external.global.submission.status.all',
    notClearable: true,
  },
  ARRIVED: {
    color: 'info',
    text: 'datagate.external.global.submission.status.arrived',
  },
  AWAITING_ARRIVAL: {
    color: 'dark',
    text: 'datagate.external.global.submission.status.awaitingArrival',
  },
  IN_PROGRESS: {
    color: 'warning',
    text: 'datagate.external.global.submission.status.inProgress',
  },
  MISSED_DEADLINE: {
    color: 'pink',
    text: 'datagate.external.global.submission.status.missedDeadline',
  },
  OK: {
    color: 'success',
    text: 'datagate.external.global.submission.status.ok',
  },
  CLOSED: {
    color: 'closed',
    text: 'datagate.external.global.submission.status.closed',
  },
  REJECTED: {
    color: 'purple',
    text: 'datagate.external.global.submission.status.rejected'
  }
};

export const submissionUploadGeneralStatuses = {
  OK: {
    text: 'datagate.external.global.submission.status.ok',
    color: 'success',
  },
  ERROR: {
    text: 'datagate.external.global.submission.generalStatus.error',
    color: 'danger',
  },
};
